import React, { useState, useEffect } from "react";
import Select from "../../../app/components/Select";
import CheckBox from "../../../app/components/CheckBox";
import { usePageTitle } from '../../../contexts/PageTitleContext';


const levelOptions = [
  { value: 'dia_anterior', label: 'Antecipar para o dia útil anterior' },
  { value: 'dia_exato', label: 'Manter o dia exato' },
  { value: 'proximo_dia', label: 'Postergar para o próximo dia útil' },
];

const Profile = () => {
  const { setTitle } = usePageTitle();

  useEffect(() => {
  setTitle('Perfil');
  }, [setTitle]); 
      
  const [formData, setFormData] = useState({
    level: '',
    vision: '',
  });
  const [imagePreview, setImagePreview] = useState(null);

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const previewURL = URL.createObjectURL(file);
      setImagePreview(previewURL);
    }
  };


  const handleSelectChange = (field) => (eOrValue) => {
    if (eOrValue?.target) {
      setFormData((prev) => ({
        ...prev,
        [field]: eOrValue.target.value,
      }));
    } else if (eOrValue?.value) {
      setFormData((prev) => ({
        ...prev,
        [field]: eOrValue.value,
      }));
    }
  };

  return (
    <div>
      <div className="flex h-[20vh] items-center gap-4 p-4">
        <label htmlFor="imgProfileInput" className="cursor-pointer">
          <img
            src={imagePreview || "https://images.pexels.com/photos/6436445/pexels-photo-6436445.jpeg"}
            alt="Avatar"
            className="h-[10vh] w-[10vh] rounded-full object-cover"
          />
          <input
            type="file"
            id="imgProfileInput"
            style={{ display: 'none' }}
            onChange={handleFileChange}
            accept="image/*"
          />
        </label>
        <div>
          <h2 className="text-[#2a1137]">Marcelly Pereira</h2>
          <h3 className="text-xs text-gray-500">marcelly@email.com</h3>
        </div>
      </div>

      <div className="mt-6">
        <h1 className="text-lg font-semibold mb-4">Dados Pessoais</h1>
        <div className="flex gap-4">
          <Select
            label="Nível"
            options={levelOptions}
            value={formData.level}
            onChange={handleSelectChange('level')}
          />
          <Select
            label="Visão"
            options={levelOptions}
            value={formData.vision}
            onChange={handleSelectChange('vision')}
          />
        </div>
      </div>
      <div>
        <h2>Departamento</h2>
        <div className="mt-2">
            <CheckBox title={'Desenvolvimento'} name={'desenvolvimento'} labelClassName="text-sm" inputClassName="!h-3 !w-3"/>
            <CheckBox title={'Sucesso'} name={'sucesso'} labelClassName="text-sm" inputClassName="!h-3 !w-3"/>
            <CheckBox title={'Comercial'} name={'comercial'} labelClassName="text-sm" inputClassName="!h-3 !w-3"/>
            <CheckBox title={'Deploy e Testes'} name={'deploy-testes'} labelClassName="text-sm" inputClassName="!h-3 !w-3"/>
            <CheckBox title={'RH'} name={'rh'} labelClassName="text-sm" inputClassName="!h-3 !w-3"/>
        </div>
      </div>
    </div>
  );
};

export default Profile;
